import React from 'react'

const ForwardIcon = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 6V1.71429C1 1.3198 1.3198 1 1.71429 1H10.2857C10.6802 1 11 1.3198 11 1.71429V10.2857C11 10.6802 10.6802 11 10.2857 11H6M3.22222 6H6M6 6V8.77779M6 6L1 11" stroke="#111AE9" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default ForwardIcon